import { Box, alpha } from '@mui/material';
import { ValidationResult } from '../utils/validation/validateSchema';
import { JsonLabel } from './DebugInfoSection';
import { JsonItem } from './JsonItem';
import { ValidationAlerts } from './ValidationAlerts';

type JsonItemWithValidationProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  item: any;
  validation?: ValidationResult;
  jsonLabels?: JsonLabel[] | string | undefined;
};

export const JsonItemWithValidation = ({
  item,
  validation,
  jsonLabels,
}: JsonItemWithValidationProps) => {
  // Determine if there are validation issues and their severity
  const hasErrors =
    validation && validation.messages.some((m) => m.severity === 'error');
  const hasWarnings =
    validation && validation.messages.some((m) => m.severity === 'warning');

  return (
    <Box
      sx={{
        mb: 3,
        borderRadius: 1,
        ...(hasErrors || hasWarnings
          ? {
              borderLeft: (theme) =>
                `4px solid ${
                  theme.palette[hasErrors ? 'error' : 'warning'].main
                }`,
              backgroundColor: (theme) =>
                alpha(
                  theme.palette[hasErrors ? 'error' : 'warning'].main,
                  0.05
                ),
              p: 2,
              boxShadow: 1,
            }
          : {}),
      }}
    >
      {validation && !validation.valid && (
        <ValidationAlerts result={validation} />
      )}
      <JsonItem item={item} jsonLabels={jsonLabels} />
    </Box>
  );
};
